var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodigoBarras({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 9,
    viewBox: "0 0 118 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14887",
    "data-name": "Grupo 14887",
    transform: "translate(12733 -6152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14886",
    "data-name": "Grupo 14886",
    transform: "translate(-12733 6152)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24503",
    "data-name": "Rect\\xE1ngulo 24503",
    width: 11,
    height: 9,
    fill: "#d4d5e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24504",
    "data-name": "Rect\\xE1ngulo 24504",
    width: 11,
    height: 9,
    transform: "translate(42)",
    fill: "#d4d5e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24505",
    "data-name": "Rect\\xE1ngulo 24505",
    width: 11,
    height: 9,
    transform: "translate(72)",
    fill: "#d4d5e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24506",
    "data-name": "Rect\\xE1ngulo 24506",
    width: 1,
    height: 9,
    transform: "translate(12)",
    fill: "#d4d5e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24507",
    "data-name": "Rect\\xE1ngulo 24507",
    width: 1,
    height: 9,
    transform: "translate(27)",
    fill: "#d4d5e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24508",
    "data-name": "Rect\\xE1ngulo 24508",
    width: 1,
    height: 9,
    transform: "translate(54)",
    fill: "#d4d5e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24509",
    "data-name": "Rect\\xE1ngulo 24509",
    width: 1,
    height: 9,
    transform: "translate(84)",
    fill: "#d4d5e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24510",
    "data-name": "Rect\\xE1ngulo 24510",
    width: 1,
    height: 9,
    transform: "translate(56)",
    fill: "#d4d5e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24511",
    "data-name": "Rect\\xE1ngulo 24511",
    width: 1,
    height: 9,
    transform: "translate(86)",
    fill: "#d4d5e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24512",
    "data-name": "Rect\\xE1ngulo 24512",
    width: 1,
    height: 9,
    transform: "translate(58)",
    fill: "#d4d5e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24513",
    "data-name": "Rect\\xE1ngulo 24513",
    width: 1,
    height: 9,
    transform: "translate(88)",
    fill: "#d4d5e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24514",
    "data-name": "Rect\\xE1ngulo 24514",
    width: 1,
    height: 9,
    transform: "translate(60)",
    fill: "#d4d5e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24515",
    "data-name": "Rect\\xE1ngulo 24515",
    width: 1,
    height: 9,
    transform: "translate(90)",
    fill: "#d4d5e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24516",
    "data-name": "Rect\\xE1ngulo 24516",
    width: 4,
    height: 9,
    transform: "translate(62)",
    fill: "#d4d5e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24517",
    "data-name": "Rect\\xE1ngulo 24517",
    width: 4,
    height: 9,
    transform: "translate(92)",
    fill: "#d4d5e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24518",
    "data-name": "Rect\\xE1ngulo 24518",
    width: 5,
    height: 9,
    transform: "translate(14)",
    fill: "#d4d5e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24519",
    "data-name": "Rect\\xE1ngulo 24519",
    width: 4,
    height: 9,
    transform: "translate(22)",
    fill: "#d4d5e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24520",
    "data-name": "Rect\\xE1ngulo 24520",
    width: 8,
    height: 9,
    transform: "translate(29)",
    fill: "#d4d5e8"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24521",
    "data-name": "Rect\\xE1ngulo 24521",
    width: 1,
    height: 9,
    transform: "translate(-12625 6152)",
    fill: "#d4d5e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24522",
    "data-name": "Rect\\xE1ngulo 24522",
    width: 5,
    height: 9,
    transform: "translate(-12631 6152)",
    fill: "#d4d5e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24523",
    "data-name": "Rect\\xE1ngulo 24523",
    width: 8,
    height: 9,
    transform: "translate(-12623 6152)",
    fill: "#d4d5e8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodigoBarras);
export default __webpack_public_path__ + "static/media/CodigoBarras.b554d1f7f92fa463c722166662111206.svg";
export { ForwardRef as ReactComponent };